import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const Btn = styled.button`
  position: absolute;
  top: 16.39%;
  left: 15%;
  width: 70%;
  height: 74%;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;

export const LinkButton = styled.button`
  position: absolute;
  top: 7%;
  left: 16%;
  width: 35%;
  height: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;

export const CopyButton = styled.button`
  position: absolute;
  top: 7%;
  left: 53%;
  width: 32%;
  height: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;
